<script setup lang="ts">
import { useRouter } from 'vue-router'

import RouteRow from '@/components/transit/RouteRow.vue'
import type { RouteAtStop } from '@/composables/useTransitIndex'

import StopScreenShell from './StopScreenShell.vue'

defineProps<{ stopId: string }>()

const router = useRouter()

/**
 * Carries the origin stop as `?stop=` so the route screen can name where the
 * user came from. Query, not a path segment: it is optional context, not part
 * of the route's identity.
 */
function openRoute(entry: RouteAtStop, stopId: string) {
  router.push({
    name: 'route',
    params: { routeCode: entry.route.code },
    query: { stop: stopId },
  })
}
</script>

<template>
  <!--
    Derived entirely from the cached dataset — this tab makes no network request.
    A stop served both ways by one route yields two entries, and both are shown,
    each with its own direction arrow, exactly as in the mockup.
  -->
  <StopScreenShell v-slot="{ routesAtStop }" :stop-id="stopId">
    <ul v-if="routesAtStop.length > 0">
      <li v-for="entry in routesAtStop" :key="`${entry.route.code}:${entry.direction}`">
        <RouteRow
          :code="entry.route.code"
          :name="entry.route.name"
          :direction="entry.direction"
          @click="openRoute(entry, stopId)"
        />
      </li>
    </ul>

    <p v-else class="p-4 text-sm text-muted-foreground">No routes pass this stop.</p>
  </StopScreenShell>
</template>
